import React from 'react';
import RModal from '../../../../../components/Rsuite/Modal';
import { CustomButton } from '../../../../../components/CustomButton';
import { CheckPicker } from 'rsuite';
import { FaPizzaSlice } from 'react-icons/fa';
import * as S from './styles';
import { useSelectFlavor } from './useSelectFlavor';

export const SelectFlavor = ({
  open,
  onClose,
  groupId,
  flavors,
  selectedFlavors,
  getSelectedFlavors,
}) => {
  const {
    parsedFlavors,
    selectedProducts,
    setSelectedProducts,
    handleSelectFlavor,
    isSaving,
  } = useSelectFlavor({
    groupId,
    flavors,
    onClose,
    selectedFlavors,
    getSelectedFlavors,
  });

  const handleClose = () => {
    setSelectedProducts([]);
    onClose();
  };

  const handleRemoveTag = (idToRemove) => {
    setSelectedProducts((prev) => prev.filter((id) => id !== idToRemove));
  };

  const hasFlavorsAvailable = parsedFlavors.length > 0;

  return (
    <RModal
      open={open}
      onClose={handleClose}
      title={'Adicionar Sabores'}
      footer={
        <>
          <CustomButton appearance="ghost" onClick={handleClose}>
            {hasFlavorsAvailable ? 'Cancelar' : 'Fechar'}
          </CustomButton>
          {hasFlavorsAvailable && (
            <CustomButton
              appearance="primary"
              onClick={handleSelectFlavor}
              disabled={isSaving || selectedProducts.length === 0}
            >
              {isSaving
                ? 'Adicionando...'
                : `Adicionar ${
                    selectedProducts.length > 0
                      ? `(${selectedProducts.length})`
                      : ''
                  }`}
            </CustomButton>
          )}
        </>
      }
    >
      <S.Container>
        {!hasFlavorsAvailable ? (
          <S.EmptyStateContainer>
            <FaPizzaSlice size={36} color="#cbd5e1" />
            <S.Title>Tudo pronto por aqui!</S.Title>
            <S.Subtitle>
              Todos os sabores disponíveis já foram adicionados a este grupo ou não há novos sabores cadastrados no sistema.
            </S.Subtitle>
          </S.EmptyStateContainer>
        ) : (
          <>
            <S.HeaderInfo>
              <S.Title>Quais sabores deseja liberar?</S.Title>
              <S.Subtitle>
                Você pode selecionar vários sabores de uma só vez. Eles ficarão
                disponíveis para o cliente escolher neste grupo.
              </S.Subtitle>
            </S.HeaderInfo>

            <CheckPicker
              data={parsedFlavors}
              value={selectedProducts}
              onChange={setSelectedProducts}
              placeholder="Busque ou selecione os sabores..."
              searchable={true}
              style={{ width: '100%' }}
              menuMaxHeight={250}
              renderValue={(value, items) => {
                return `Selecionados (${value.length})`;
              }}
            />
            {selectedProducts.length > 0 && (
              <S.SelectedSummary>
                <p>Você está prestes a adicionar:</p>
                <div className="tags-wrapper">
                  {parsedFlavors
                    .filter((f) => selectedProducts.includes(f.value))
                    .map((flavor) => (
                      <S.CustomTag key={flavor.value}>
                        <span>{flavor.label}</span>
                        <button
                          onClick={() => handleRemoveTag(flavor.value)}
                          title="Remover"
                        >
                          ×
                        </button>
                      </S.CustomTag>
                    ))}
                </div>
              </S.SelectedSummary>
            )}
          </>
        )}
      </S.Container>
    </RModal>
  );
};
